// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=7613-182239
// Component: SectionHeading
// Numbered section label: dark circle badge + uppercase condensed title

export default function SectionHeading({ number, title, error = false, innerRef }) {
  return (
    <div className="flex items-center gap-2" ref={innerRef}>
      <div className={`shrink-0 size-[22px] rounded-full flex items-center justify-center text-white text-[13px] font-semibold leading-none ${error ? 'bg-[#E30713]' : 'bg-[#17181A]'}`}>
        {number}
      </div>
      <span className={`text-[17px] font-semibold tracking-[-0.34px] ${error ? 'text-[#E30713]' : 'text-[#17181A]'}`}>
        {title}
      </span>
    </div>
  )
}
